import { useEffect, useRef, useState } from 'react';

/**
 * Egyszer igazra vált, amikor az elem a viewportba ér (IntersectionObserver) — a framer
 * `whileInView` + `viewport={{ once: true }}` párja, CSS-átmenetekhez. `margin` = rootMargin.
 */
export function useInViewOnce<T extends HTMLElement>(margin = '-60px') {
  const ref = useRef<T>(null);
  // Ha nincs IntersectionObserver (nagyon régi böngésző), rögtön láthatónak vesszük — így nincs
  // szinkron setState az effectben (kaszkádoló renderek).
  const [inView, setInView] = useState(() => typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) { setInView(true); io.disconnect(); }
      },
      { rootMargin: margin },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [margin, inView]);

  return [ref, inView] as const;
}
